/**
 * Accordion
 */
document.querySelectorAll(".js-accordion").forEach(function (e) {
    e.addEventListener("click", function (event) {
        event.target.classList.toggle("active");
    });

});

/**
 * #######################
 *  JQuery Section
 * #######################
 */

function popupFadeToggle(classOpen, classClose, className) {
    $(classOpen).click(function () {
        event.preventDefault();
        $(className).fadeIn();
    });

    $(classClose).click(function () {
        event.preventDefault();
        $(className).fadeOut();
    });
}

document.addEventListener('scroll', function(e) {
    if(window.scrollY > 56) {
        document.body.classList.add('sticky');
    }else {
        document.body.classList.remove('sticky');
    }
});

$(document).ready(function () {
    /**
     * Search Hide Show
     */
    popupFadeToggle('.js-search-open', '.js-search-close', '.js-search');

    /**
     * Slider active Link complete on mobile
     */
    $(document).on('click', '.js-urlMobile', function () {
        if ($(window).width() <= 1299) {
            window.location.href = $(this).attr('data-url');
        }
    });
});

const actionKeys = ['ArrowLeft','ArrowRight','Backspace','Delete','Tab'];
const telPattern = [/\(/,/\d/,/\d/,/\)/,/\s/,/\d/,/\d/,/\d/,/\d/,/\d/,/-/,/\d/,/\d/,/\d/];

/** @type {HTMLInputElement[]} */
const telInputs = document.querySelectorAll('input[type="tel"]');
telInputs.forEach(telInput => {
    const isAcceptable = new RegExp(/[0-9\(\)\s\-+./]/);

    telInput.addEventListener('keydown', function(e) {
        if(actionKeys.indexOf(e.key) !== -1) return;
        if(!telPattern[e.target.value.length]) return;
        
        let currTest = telPattern[e.target.value.length];

        if(!isAcceptable.test(e.key)) {
            e.preventDefault();
            return;
        }else {
            let newValue = e.target.value;
            while(telPattern[newValue.length].test(e.key) === false){
                let char = currTest.source.replace(/[\/\\]/g, '');
                char = char === 's' ? ' ' : char;
                
                newValue += char;
                currTest = telPattern[newValue.length];
            }

            e.target.value = newValue;
        }
    });
})

function eventLanguagesSystem(videoPlayer) {
    const webcastContainer = document.getElementById('webcast');
    const langBtns = document.querySelectorAll(".pages__banner > .box .languages > .btn");

    if (webcastContainer) {
        langBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                if (webcastContainer.getAttribute('src') !== e.target.getAttribute('data-video')) {
                    videoPlayer.src({
                        src: e.target.getAttribute('data-video')
                    });
                    document.querySelector('.pages__banner .languages > .btn.active').classList.remove('active');
                    e.target.classList.add('active');
                }
            });
        });
    }
}

$(document).ready(function () {
    $('.js-search').on('click', function(event) {
        event.stopPropagation();
        $(this).fadeOut();
    });

    $('.js-search *').on('click', function(event) {
        event.stopPropagation();
    });
});